export default __webpack_public_path__ + "static/media/amorimWise.0685e9e3.svg";